import { useState, useEffect } from 'react';

const STORAGE_KEY = 'selora_currency';

export function useCurrency() {
  const [currency, setCurrencyState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'EUR';
    } catch {
      return 'EUR';
    }
  });

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return;

    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(data => {
        if (data.country_code === 'IN') {
          setCurrencyState('INR');
          localStorage.setItem(STORAGE_KEY, 'INR');
        } else {
          localStorage.setItem(STORAGE_KEY, 'EUR');
        }
      })
      .catch(() => {
        localStorage.setItem(STORAGE_KEY, 'EUR');
      });
  }, []);

  const setCurrency = (val) => {
    setCurrencyState(val);
    try { localStorage.setItem(STORAGE_KEY, val); } catch {}
  };

  return { currency, setCurrency };
}

export function formatPrice(eur, inr, currency) {
  return currency === 'INR' ? `₹${inr.toLocaleString('en-IN')}` : `€${eur}`;
}
